import './styles/tokens.css';
import './styles/base.css';
import './styles/components.css';
import './styles/utilities.css';
import { bootstrapApp } from './app/bootstrap';

/**
 * Zuri Web App — Main Entry Point
 * Boots the application by initializing stores, routes, and app shell.
 */
document.addEventListener('DOMContentLoaded', () => {
  try {
    bootstrapApp();
  } catch (err) {
    console.error('Failed to bootstrap application:', err);
    const appEl = document.getElementById('app');
    if (appEl) {
      appEl.innerHTML = `
        <div class="empty-state" style="padding-top:120px">
          <i class="fa-solid fa-triangle-exclamation"></i>
          <h2>Something went wrong</h2>
          <p>Please refresh the page or try again later.</p>
        </div>
      `;
    }
  }
});